import { Component, OnInit, Inject, OnDestroy, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FormBuilder, Validators, FormArray, FormGroup, FormControl } from '@angular/forms';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { cloneControl } from 'app/e-form/helper/script/cloneAbstract';
import { MessageBoxComponent } from '../../../shared/message-box/message-box';
import { TranslateService } from '@ngx-translate/core';
import { ValidatorConfigure } from 'app/e-form/config/validator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HelperTransalaterService } from 'app/e-form/service/helper-translate.service';
import { EditDialogComponent } from '../edit-dialog/edit-dialog.component';
import { EformAPI } from 'app/e-form/e-form.api';
import { ChoiceDataSourceEntity, Item, LanguageItem, LanguageStatic, Lookup } from 'app/e-form/model/lookup';
import { UUID } from 'app/e-form/helper/script/uuid';
import { Toast } from 'app/shared/toast/toast';
import { LookUpConverter } from 'app/e-form/helper/script/lookupConverter';
@Component({
   selector: 'app-choice-lookup',
   templateUrl: './choice-lookup.component.html',
   styleUrls: ['./choice-lookup.component.scss']
})
export class ChoiceLookupComponent implements OnInit, OnDestroy {
   @ViewChildren('input_req') divs: QueryList<ElementRef>;
   helper = new EFormHelper();
   lookupConvert = new LookUpConverter(this.data.eForm, this.fb);
   uuid = new UUID();
   loading = false;
   existingForm: FormGroup;
   tableList = [];
   choiceType = '';
   tableConfigure: FormGroup;
   displayedColumns = ['select', 'lang', 'menu'];
   langSource = [];
   matTab = 0;
   defaultValue = this.data.defaultValue;
   validators = new ValidatorConfigure();
   tmpEform: FormArray;
   duplicateType = '';
   langSupport = [];
   isEdit = false;
   original = this.data.eForm.controls.original.value;
   tmpDataSource = [];
   private _dynamicIndex = 0;
   company = localStorage.getItem('tin');
   dataSource = new MatTableDataSource<any>(this.tmpDataSource);
   selection = new SelectionModel<any>(false, []);
   isInvalidDragEvent = false;
   constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ChoiceLookupComponent>,
      private dialog: MatDialog, private fb: FormBuilder, private translate: TranslateService,
      private helperTranslater: HelperTransalaterService, private api: EformAPI, private toast: Toast) {
         const _fieldGroup = data.field as FormGroup;
         this.choiceType = _fieldGroup.value.type;
       }

   ngOnInit(): void {
      const _tableName = this.data.field.value.choiceLookUp.tableName === '' ? '' :
                         {tableName: this.data.field.value.choiceLookUp.tableName, id: this.data.field.value.choiceLookUp.id};
      this.existingForm = this.fb.group({
         id: '',
         tableName: [_tableName, Validators.required],
         displayName: [{ value: '', disabled: true }],
         displayValue: [{ value: '', disabled: true }, ],
         activeAssosiate: [false],
         assosiateTable: [''],
         assosiateValue: [{ value: '', disabled: true }],
         assosiateKey: [{ value: '', disabled: true }],
      });
      this.initailizeDataSource();
      this.supplyInitsLabels();
      this._setUpDefaultValue();
      this.setPosition();
      this.api.getListMasterTable(this.company).subscribe(v => this.tableList = v);
      this.existingForm.markAllAsTouched();
      this.existingForm.markAsDirty();
      this._refreshMatable();
   }

   compareObjects(o1: any, o2: any): boolean {
      return o1?.tableName === o2?.tableName && o1?.id === o2?.id;
    }

   ngOnDestroy(): void {
      this.existingForm.reset();
   }

   initailizeDataSource() {
      this.tmpEform = cloneControl<FormArray>(this.data.choice);
      Object.keys(this.tmpEform.at(0).value.label).forEach(v => this.langSupport.push(v));
      Object.keys(this.tmpEform.controls).forEach((_val, index) => {
         const _l = this.tmpEform.controls[_val];
         this.createRows(_l.value.label, _l.value.value, index, _l.value.isPrompt);
      });
      moveItemInArray(this.langSupport, this.langSupport.findIndex(v => v === this.original), 0);
   }

   setPosition() {
      const _menu = this.displayedColumns.findIndex(v => v === 'menu');
      moveItemInArray(this.displayedColumns, _menu, this.displayedColumns.length - 1);
   }

   createRows(data: FormControl, val: string, index: number, promptValue) {
      const _data = data;
      const _dataArrayLabel = [];
      const _preArray = (value: any, lang: string) => {
         const _prepare = value;
         Object.assign(_prepare, { lang: lang, index: index, isPrompt : promptValue,
                                   validMain: true , validValue: true });
         return _prepare;
      };
      _dataArrayLabel.push(_preArray(_data, val));
      _dataArrayLabel.forEach(v => {
         this.tmpDataSource.push(v);
      });
   }

   supplyInitsLabels() {
      const _notDuplicated = (check) => this.displayedColumns.some(v => v === check);
      const _notCommon = (s) => s !== 'index' && s !== 'isPrompt' && s !== 'validMain'
                               && s !== 'validValue';
      for (const [lang, value] of Object.entries(this.tmpDataSource)) {
         this.tmpDataSource.forEach(v => {
            Object.keys(v).forEach(s => {
               if (value[s] !== '' && !_notDuplicated(s) && _notCommon(s)) {
                  this.displayedColumns.push(s);
                  return;
               }
            });
         });
      }
      if (!_notDuplicated(this.data.eForm.controls.original.value)) {
         this.displayedColumns.push(this.data.eForm.controls.original.value);
      }
      const _index = this.displayedColumns.findIndex(v => v === this.original);
      moveItemInArray(this.displayedColumns, _index, 2);
   }

   addNewLang(number) {
      this.setEdit();
      this.displayedColumns.push('temp' + number);
      this.setPosition();
   }

   check(): boolean {
      return this.langSupport.length <= (this.displayedColumns.length - 3);
   }

   localName(lid: string) {
      let _text;
      this.translate.get('eform.lang').subscribe(v => {
         _text = v[lid];
      });
      return _text;
   }

   selectLangs(newColumn: string, oldColumn, cId) {
      let _newIndex;
      _newIndex = newColumn.startsWith('temp') ? 'temp' + this._dynamicIndex++ : newColumn;

      this.displayedColumns[cId] = _newIndex;
      this.dataSource.data.forEach(v => {
         v[_newIndex] = v[oldColumn];
         v[oldColumn] = '';
      });
      this._sortOriginal();
      this.setEdit();
   }

   checkErrors(_value: string) {
      return _value === '' ? true : false;
   }

   checkDuplicate(_value: string) {
      const valueArr = this.dataSource.data.map((item) => item.lang) as Array<string>;
      const isDuplicate = valueArr.some((item, idx) => {
         const _tmp = valueArr.filter(v => v === _value);
         if (_tmp.length >= 2) {
            return true;
         } else {
            return false;
         }
      });
      return _value !== '' ? isDuplicate : false;
   }

   resetValue(resetLang: string) {
      this.dataSource.data.forEach(obj => {
         for (const key in obj) { if (key === resetLang) { obj[key] = ''; } }
      });
      this.setEdit();
   }

   duplicateRow(langKey, _index) {
      const _indexTemp = _index + 1;
      const _sourceTemp = [];
      const _pushTemp = (obj: Object) => {
         for (const key in obj) {
            if (key === langKey) {
               _sourceTemp.push(obj[key] === '' ? '' : obj[key]);
            }
         }
      };
      this.duplicateType = langKey;
      let _displayIndex;
      _displayIndex = 'temp' + this.displayedColumns.length;
      this.displayedColumns.splice(_indexTemp, 0, _displayIndex);
      this.dataSource.data.forEach(obj => _pushTemp(obj));

      this._duplicateRow(_displayIndex, _sourceTemp);
      this.setEdit();
   }

   private _duplicateRow(langKey: string, obj: Array<string>) {
      const _reAssign = (index2, v2) => {
         obj.forEach((v, index) => {
            if (index2 === index) { v2[langKey] = v; }
         });
      };
      this.dataSource.data.forEach((v2, index2) => _reAssign(index2, v2));
   }

   setEdit() {
      if (!this.isEdit) { this.isEdit = true; }
   }

   canSelection(value: string): boolean {
      return this.displayedColumns.some(v => v === value);
   }

   addRows(index?) {
      this.setEdit();
      const _val = {};
      const reOrder = () => {
         this.dataSource.data.forEach((v, i) => {
            v.index = i;
         });
      };

      Object.keys(this.dataSource.data[0]).forEach(key => {
         let _tmp: Object = {};
         switch (key) {
            case 'index' :  _tmp = {[key]: index + 1 }; break;
            case 'isPrompt' :
            case 'validMain' :
            case 'validValue' : _tmp = {[key]: false}; break;
            default: _tmp = {[key]: ''}; break;
         }
         Object.assign(_val, _tmp);
   });
      if (index !== '' && index !== undefined) {
         this.dataSource.data.splice(index + 1, 0, _val);
      } else {
         this.dataSource.data.push(_val);
      }
      reOrder();
      this._renderSource();
      setTimeout(() => { this.divs.last.nativeElement.focus(); }, 500);
   }

   deleteRow(index) {
      this.dataSource.data.splice(index, 1);
      if (this.defaultValue !== null && this.defaultValue !== undefined) {
         this.defaultValue = this.defaultValue.index === index ? null : this.defaultValue;
      }
      this._renderSource();
      this.setEdit();
   }

   drop(event: CdkDragDrop<any[]>) {
      moveItemInArray(this.dataSource.data, event.previousIndex, event.currentIndex);
      const findIndexPromp = () => {
         const index = this.dataSource.data.findIndex(v => v.isPrompt);
         moveItemInArray(this.dataSource.data, index, 0);
      };
      findIndexPromp();
      this._renderSource();
      this.setEdit();
   }

   dragStarted() {
      if (this.isInvalidDragEvent) {
         document.dispatchEvent(new Event('mouseup'));
      }
   }

   onInvalidDragEventMouseDown(b) {
      this.isInvalidDragEvent = b;
   }

   checkbox(row, event) {
      setTimeout(() => {
         if (event) {
            this.defaultValue = row;
         } else {
            this.defaultValue = null;
         }
      }, 50);
   }

   containingTmp() {
      let _boolean = false;
      this.displayedColumns.forEach(v => {
         if (v.startsWith('temp')) {
            _boolean = true;
         }
      });
      return _boolean;
   }

   save(): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-containing-cancel-save'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getTagEform('button.yes'),
            action: () => this._ok()
         },
         close: {
            label: this.helperTranslater.getTagEform('button.no'),
            action: () => true
         }
      };
      this.containingTmp() ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._ok();
   }

   saveSetup() {
      const _field = this.data.field as FormGroup;
      const _choices = _field.controls.choiceTmp as FormArray;
      const prepare = (value, label) => {
         const _tmp = new FormGroup({
            'value': new FormControl(value),
            'isPrompt' : new FormControl(label.isPrompt),
            'label': new FormGroup({
               'th': new FormControl(label.th),
               'en': new FormControl(label.en)
            })
         });
         _choices.push(_tmp);
      };
      _choices.clear();
      this.dataSource.data.forEach(v => {
         prepare(v.lang, v);
      });
      _field.controls.tempLookupDefault.setValue(this._saveDefault());
      this.close();
   }

   private _saveDefault() {
      return (this.defaultValue === null || this.defaultValue === undefined) ? -1 : this.defaultValue.lang;

   }

   deleteActions(column): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-delete-column'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getTagEform('button.yes'),
            action: () => this._deleteAction(column)
         },
         close: {
            label: this.helperTranslater.getTagEform('button.no'),
            action: () => true
         }
      };
      this.dialog.open(MessageBoxComponent, { disableClose: true, data });
   }

   close() {
      this.dialogRef.close('send back');
   }

   cancel(): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-cancel-save'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getSingleTranslation('create_tasks.save'),
            action: () => this._ok()
         },
         close: {
            label: this.helperTranslater.getTagEform('button.dont-save'),
            action: () => this._close()
         }
      };
      this.isEdit && this.existingForm.controls.tableName.valid && !this.canSave() && this._isDuplicate() ?
      this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._close();
   }

   _ok() {
      this.matTab === 0 ? this.saveTable() : this.saveLookup();
      return true;
   }

   _close() {
      this.dialog.closeAll();
      return true;
   }

   openEditDialog(column) {
      const _obj = this.dataSource.data.map(v => v[column]);
      const _dialog = this.dialog.open(EditDialogComponent, { disableClose: true, data: _obj });
      const _mustbeAddMore = (_source, _target) => {
         if (_source < _target) {
            let _count = _target - _source;
            while (_count !== 0) {
               this.addRows();
               _count--;
            }
         }
      };
      _dialog.afterClosed().subscribe(v => {
         if (v) {
            _mustbeAddMore(this.dataSource.data.length, v.length);
            v.forEach((_val, index) => {
               this.dataSource.data.forEach((_val2, index2) => {
                  if (index === index2) {
                     _val2[column] = _val;
                  } else if (index < index2) {
                     _val2[column] = '';
                  }
               });
            });
         }
      });
   }

   private _setUpDefaultValue() {
      const _array = this.dataSource.data.find(v => {
         return v.lang === this.defaultValue.toString();
      });
      this.defaultValue = _array;
   }

   private _renderSource() {
      this.dataSource.data = [...this.dataSource.data];
   }

   private _sortOriginal(): void {
      const _index1 = this.displayedColumns.findIndex(v => v === this.original);
      if (_index1 !== -1) { moveItemInArray(this.displayedColumns, _index1, 2); }
   }

   private _deleteAction(resetLang: string) {
      this.resetValue(resetLang);
      this.displayedColumns.splice(this.displayedColumns.indexOf(resetLang), 1);
      this.setEdit();
      return true;
   }

   selectionChange(value, type) {
      const _enable = (typeEnable: string) => {
         this.existingForm.controls[typeEnable].enable();
      };

      const _disable = (typeDisable: string) => {
         this.existingForm.controls[typeDisable].disable();
      };

      const _clearValue = () => {
         const _clear = (typeClear: string) => { this.existingForm.controls[typeClear].setValue(''); };
      };

      switch (type) {
         case 'masterTable': value ? _enable('displayName') : _disable('displayName'); break;
         case 'displayName': value ? _enable('displayValue') : _disable('displayValue'); break;
         case 'assosiateTable': value ? _enable('assosiateValue') : _disable('assosiateValue'); break;
         case 'assosiateValue': value ? _enable('assosiateKey') : _disable('assosiateKey'); break;
         default: break;
      }
      this.existingForm.updateValueAndValidity();
      this.existingForm.markAllAsTouched();
      this.setEdit();
   }

   matTabChange(tab) {
      if (tab === 1) {
         this.tableConfigure = this.fb.group({
            tableName: ['', Validators.required],
            description: ['']
         });
         this.tableConfigure.controls.tableName.setErrors({duplicate: false});
         this.tableConfigure.markAllAsTouched();
      } else {
         this.existingForm.markAllAsTouched();
      }
   }

   saveLookup() {
      this.loading = true;
      const lookupModel = new Lookup();
      lookupModel.id = this.uuid.getUUIDV4;
      lookupModel.defaultValue = this._saveDefault();
      lookupModel.description = this.tableConfigure.value.description;
      lookupModel.name = this.tableConfigure.value.tableName;
      lookupModel.languageItems = [];

      const langugaeItem: LanguageItem = {
         languageStaticData: []
      };

      const notCommon = (v: string) => v !== 'lang' && v !== 'select' &&
                                       v !== 'menu' && !v.startsWith('temp');
      this.displayedColumns.forEach(response => {
         if (notCommon(response)) {
            const rows: Item = {
               choiceDataSourceEntity: []
            };

            const langStatic: LanguageStatic = {
               items: rows,
               language: response
            };

            langugaeItem.languageStaticData.push(langStatic);
         }
      });
      lookupModel.languageItems.push(langugaeItem);

      langugaeItem.languageStaticData.forEach(resp1 => {
         this.dataSource.data.forEach(listdata => {
            const rows: ChoiceDataSourceEntity = {
               id: this.uuid.getUUIDV4,
               displayMember: listdata[resp1.language],
               isDefaultValue: this.defaultValue?.index === listdata.index,
               valueMember: listdata.lang
            };
            resp1.items.choiceDataSourceEntity.push(rows);
         });
      });

      this.api.createLookup(lookupModel.name, 'Company', lookupModel, this.company).subscribe((res) => {
         const _field = this.data.field as FormGroup;
         const _lookup = _field.controls.choiceLookUp as FormGroup;
         _lookup.controls.id.setValue(res.id);
         _lookup.controls.tableName.setValue(res.name);
         this.saveSetup();
      }, (err) => {
         this.toast.error(err);
      }).add(() => this.loading = false);
   }

   getTableType() {
      return this.existingForm.controls.tableName?.value;
   }

   saveTable() {
      this.loading = true;
      const _field = this.data.field as FormGroup;
      const _choices = _field.controls.choiceTmp as FormArray;
      const _lookup = _field.controls.choiceLookUp as FormGroup;
      _lookup.controls.id.setValue(this.getTableType().id);
      _lookup.controls.tableName.setValue(this.getTableType().tableName);

      this.api.getLookup(this.getTableType().id).subscribe(lookup => {
         const _tmpObjects  = this.lookupConvert._filterObjects(lookup);
         _field.controls.tempLookupDefault.setValue(lookup.defaultValue);
         _choices.clear();
         this.lookupConvert._prepareChoices(_tmpObjects, _choices);
      }, (err) => { console.error(err);
      }, ()    => this._close())
       .add(() => this.loading = false);
   }

   canSave(): boolean {
      if (this.matTab === 1) {
         const y = this.dataSource.data.some((item) => !item.validMain);
         const x = this.dataSource.data.some((item) => !item.validValue);
         const _condition = y || x ;
         return this.tableConfigure.invalid || this.loading || _condition;
      } else {
         return  this.existingForm.invalid || this.loading ;
      }
   }

   addPrompt(event) {
      const key = [];
      const tempPrompt = { lang: '', index: 8001, isPrompt: true, validMain: true, validValue: true};
      const notCommon = (v: string) => v !== 'lang' && v !== 'select' &&
         v !== 'menu' && !v.startsWith('temp');

      if (event.checked) {
         this.displayedColumns.forEach(v => {
            if (notCommon(v)) {
               key.push(v);
            }
         });

         key.forEach((responseKey) => {
            let text = '';
            switch (responseKey) {
               case 'th': text = '--- กรุณาเลือก ---'; break;
               case 'en': text = '--- Please Select ---'; break;
            }
            Object.assign(tempPrompt, { [responseKey]: text });
         });
         this.dataSource.data.unshift(tempPrompt);
      } else {
         this.dataSource.data.shift();
      }
      this._renderSource();
      this.activePrompt();
      this.setEdit();
   }

   activePrompt() {
      return  this.dataSource.data.findIndex(v => v.isPrompt);
   }

   checkValidator(item, value, active, type) {
      if (active) {
         if (type === 'main') {
            item.validMain = value === '' ? false : true;
         } else {
            const noValue = value === '' ? false : true;
            let duplicate = true;
            if (this.checkDuplicate(value)) {
               duplicate = false;
            }
            item.validValue = noValue;
         }
      }
   }

   _isDuplicate() {
      const _list = [];
      this.dataSource.data.forEach(v => _list.push(v.lang));
      const findDuplicates = arr => arr.filter((itemx, index) => arr.indexOf(itemx) !== index);
      return findDuplicates(_list).length === 0;
   }

   checkExistingTable() {
      const tableName = this.tableConfigure.value.tableName;
      const assignvalidators = (existing: boolean) => {
         const control = this.tableConfigure.controls.tableName as FormControl;
         if (existing) {
            control.setErrors({duplicate : true});
         }
      };
      if (tableName !== '') {
         this.api.existingTableName(this.company, tableName).subscribe((res: boolean) => {
            assignvalidators(res);
         });
      }
   }

   private _refreshMatable() {
      setTimeout(() => {
         this.dataSource.data.push({items: 'tmpRow'});
         this._renderSource();
         this.dataSource.data.pop();
         this._renderSource();
      }, 200);

   }


}
